import { initializeApp } from "firebase/app"
import {getAuth} from 'firebase/auth'
import { getFirestore } from "firebase/firestore";
import { getFunctions } from 'firebase/functions';
import { getStorage } from 'firebase/storage';
const firebaseConfig = {
    apiKey: "AIzaSyBPxVQ1lg4BH0lMcdF6a80tn8pojvD7gvU",
    authDomain: "vauras-capital.firebaseapp.com",
    projectId: "vauras-capital",
    storageBucket: "vauras-capital.firebasestorage.app",
    messagingSenderId: "449689432421",
    appId: "1:449689432421:web:8a91c16b4e624cc249718c",
    measurementId: "G-R0WKS7JVHW"
};

const firebaseApp = initializeApp(firebaseConfig)
const auth = getAuth(firebaseApp)
const db = getFirestore(firebaseApp)
const functions = getFunctions(firebaseApp);
const storage = getStorage(firebaseApp);

export { db, auth, functions, storage }